import { ChangeDetectionStrategy, Component, Input } from '@angular/core'

@Component({
  selector: 'bmcore-play-icon',
  templateUrl: './bmcore-play-icon.component.html',
  styleUrls: ['./bmcore-play-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcorePlayIconComponent {
  @Input() fillColor = 'currentColor'
  @Input() width = 32
  @Input() height = 32
}
